import { getKey, setKey } from './localStorage';

const KEEP_BETS_SETTINGS = 'keepBetsSettings';

export function getKeepBetsSettings() {
    const lsValue = getKey(KEEP_BETS_SETTINGS);
    return lsValue ? JSON.parse(lsValue) : false;
}

export function setKeepBetsSettings(value = false) {
    return setKey(KEEP_BETS_SETTINGS, value);
}
